// Client replies to the controller's client texts (Rod 2026-10-08 ~12:15 pm): photo replies are filed to the case by the controller;
// TEXT replies ("I don't have insurance") are only held for a person, and with staff tasks off nobody saw them. Pure: no I/O.
// Our texts are recognised by their approved wording (controller/adapters/client_text.js), English or Spanish.
import { sideOf } from './side.js';
const norm = (s) => String(s ?? '').replace(/\s+/g, ' ').trim();
// The opening of each approved text: enough to tell them apart and from anything else the firm sends.
const OURS = [
    ['Sweet James Accident Attorneys: to open your insurance claim we need your auto insurance policy number.', 'policy'],
    ['Sweet James Accident Attorneys: para abrir su reclamo de seguro necesitamos el número de póliza de su seguro de auto.', 'policy'],
    ['Sweet James Accident Attorneys: to open your insurance claim we need your auto insurance information.', 'noplt'],
    ['Sweet James Accident Attorneys: para abrir su reclamo de seguro necesitamos la información de su seguro de auto.', 'noplt'],
    // its pedestrian / bicycle / scooter form (Rod 10-08 "4 ok", controller NOPLT_PED_TEXT[_ES]); the Spanish was first written "aun" (controller d474ea3: none sent, caps 0), now "aún"; both match
    ['Sweet James Accident Attorneys: even as a pedestrian, your own auto insurance may cover your medical bills.', 'noplt'],
    ['Sweet James Accident Attorneys: aún como peatón, su propio seguro de auto puede cubrir sus gastos médicos.', 'noplt'],
    ['Sweet James Accident Attorneys: aun como peatón, su propio seguro de auto puede cubrir sus gastos médicos.', 'noplt'],
];
export function ourTextKind(body) {
    const b = norm(body);
    for (const [start, kind] of OURS)
        if (b.startsWith(start))
            return kind;
    return null;
}
export const OUR_TEXT_LABEL = { policy: 'the policy # text', noplt: 'the no-PLT card text' };
export const REPLY_NEED = {
    no_insurance: 'Says no insurance: confirm and close the PLT ask',
    info: 'Sent info in text: enter it',
    question: 'Asked a question: call the client',
    opt_out: 'Asked us to stop texting: call instead, no more texts',
    other: 'Replied: read it and follow up',
    photo: null,
};
const LABEL = {
    no_insurance: 'Client replied: no insurance', info: 'Client replied with insurance info', question: 'Client replied with a question',
    opt_out: 'Client asked us to stop texting', other: 'Client replied', photo: 'Client sent a photo (filed)',
};
// The "no insurance" phrases and the exclusions are the controller's own (sj-insurance-router feat/claims-controller-noplt-text
// lib/claims_controller/no_insurance_reply.js @27eb3cd, the reply auto-close), so a reply the controller would close always reads
// "says no insurance" here. Console-only additions (a person confirms; tell the controller agent): "aseguransa", the run-together
// "yono tengo", and "no me manden" as stop.
const QUESTION = /[?¿]/;
const STOP = /\b(stop|unsubscribe|cancel|quit|end|parar|alto|basta|no\s+me\s+manden)\b/i;
const CALL = /\b(call(ing)?\s*(me|back|us)?|phone\s*me|ll[aá]m(a|e|en|eme|enme|ar)\w*|marc(a|ar|ame)\w*)\b/i;
const NOT_PURSUE = /\b(not\s+(pursue|pursuing|interested|continue|continuing|going\s+(forward|ahead))|no\s+desire|(do\s*n[o']?t|dont)\s+want|no\s+quiero|no\s+me\s+interesa|drop\s+(the|my)\s+case|withdraw)\b/i;
const CARRIER = new RegExp('\\b(state\\s*farm|allstate|progressive|geico|farmers|mercury|aaa|csaa|alinsco|national\\s+general|integon|nationwide|liberty|usaa|'
    + 'travelers|kemper|infinity|bristol|aspire|safeco|esurance|root|dairyland|bluefire|anchor|wawanesa|hartford|tesla|acceptance|freedom|fred\\s+loya|'
    + 'good2go|sentry|insurance\\s+company|mutual|casualty|medi-?cal|medicare|medicaid|kaiser|blue\\s*(cross|shield)|aetna|cigna|united\\s*health)\\b', 'i');
const POLICY_LIKE = /\d{5,}|\b[A-Za-z]{1,4}[- ]?\d{4,}\b/;
const OTHER_PARTY = /\b(other\s+(driver|car|party|person|vehicle)|the\s+(driver|guy|lady|man|woman)|at[- ]fault|hit\s+(me|us)|he|she|they|them|him|her|his|el\s+otro|la\s+otra|ella|ellos)\b/i;
const EN_NO_INS = /\b(i|we)\s*(do\s*n[o']?t|dont|do\s+not|don['’]t)\s+have\s+(any\s+)?((auto|car|vehicle)\s+)?insurance\b(?!\s*(card|info|information|paper|papers|docs?|documents?|policy|number|with\s+me|on\s+me|right\s+now|yet|at\s+the\s+moment|handy))/i;
const EN_NO_INS_SHORT = /^\s*(no[,.!\s]*)?(i\s+have\s+)?no\s+((auto|car)\s+)?insurance\s*[.!]*\s*((sorry|thanks|thank\s+you|thx|ty)\s*[.!]*)?\s*$/i;
const EN_NO_CAR = /\b(i|we)\s*(do\s*n[o']?t|dont|do\s+not|don['’]t)\s+(have|own)\s+a\s+(car|vehicle)\b/i;
const EN_NONE_WHOLE = /^\s*(no[,.!\s]*)?(i|we)\s*(do\s*n[o']?t|dont|do\s+not|don['’]t)\s+have\s+(any|one|it)\s*[.!]*\s*((sorry|thanks|thank\s+you|thx|ty)\s*[.!]*)?\s*$/i;
const ES_NO_INS = /\b(?:yo)?no\s+(tengo|tenemos)\s+(ning[uú]n\s+)?(seguro|aseguranza|aseguransa)\b(?!\s+(conmigo|aqu[ií]|ahorita|ahora|todav[ií]a))/i;
const ES_NO_CAR = /\b(?:yo)?no\s+(tengo|tenemos)\s+(carro|auto|coche|veh[ií]culo|carro\s+propio)\b/i;
const NO_INS = [EN_NO_INS, EN_NO_INS_SHORT, EN_NO_CAR, EN_NONE_WHOLE, ES_NO_INS, ES_NO_CAR];
// the controller's own (no_insurance_reply.js @4e48e43, Rod 10-08 "4 ok": the pedestrian text asks 'If you don't, reply "none"'): a WHOLE reply of
// only "none" / "ninguno" / "no" counts, but only answering a no-PLT text, never the policy # text, where "no" can mean "not now"
const BARE_NONE = /^\s*(no+|nope|none|ninguno|ninguna|nada|no\s+tengo)\s*[,.!]*\s*((sorry|thanks|thank\s+you|thx|ty|gracias)\s*[.!]*)?\s*$/i;
// console-only: questions without a question mark ("no entiendo cual seguro")
const QUESTION_WORDS = /\b(no entiendo|por qu[eé]|qu[eé] seguro|cu[aá]l seguro)\b/i;
export function classifyReply(text, media, answered) {
    const t = norm(text);
    const pick = (kind) => ({ kind, label: LABEL[kind], need: REPLY_NEED[kind] });
    if (media)
        return pick('photo');
    if (!t)
        return pick('other');
    if (QUESTION.test(t))
        return pick('question');
    if (STOP.test(t))
        return pick('opt_out');
    if (CALL.test(t))
        return pick('question'); // "call me": the Need is to call the client
    if (NOT_PURSUE.test(t))
        return pick('other');
    if (CARRIER.test(t) || POLICY_LIKE.test(t))
        return pick('info');
    if (OTHER_PARTY.test(t))
        return pick('other'); // about the other driver, never ours
    if (NO_INS.some((re) => re.test(t)))
        return pick('no_insurance');
    if (answered === 'noplt' && BARE_NONE.test(t))
        return pick('no_insurance');
    if (QUESTION_WORDS.test(t))
        return pick('question');
    return pick('other');
}
/** A text reply waits for a person until something happens on the case after it: a staff note, a PLT record made after it, a PLT claim. */
export function replyWaiting(r) {
    // Neila 2026-10-13 5:24 pm: "There's something that says 'resolved' in banjaxed if we've responded": a resolved conversation is answered
    if (r.resolved === true)
        return false;
    // 2026-10-09: a "no insurance" reply the controller acted on (it closed the 1P task) no longer waits for a person
    if (r.kind === 'no_insurance' && r.closed1p)
        return false;
    return r.kind !== 'photo' && !r.laterStaffNote && !r.pltAfter && !r.pltClaim;
}
/** Cesar 2026-10-14 (MAT a0LQn00000uRiEPMA0): a person answered the reply in the console. A fact a person entered on the case's own (PLT)
 *  side after the reply (no 1P insurance, a carrier, a policy number, a phone, a claim number) means the client's answer was taken: the
 *  reply no longer waits. The console's case note is written by the automation user, so the staff-note check never sees it. A fact that
 *  FAILED does not count (the write did not land); the Send LOR button is not an answer to the client. Codex 10-14 #48 #1: a fact on a
 *  record answers only the reply on that record (the board's reply row: the first PLT record with no claim number, else the side's gap);
 *  where the case's records are not known here, only a side-level fact (no record) counts. Pure; facts absent = every reply waits. */
export function answeredByFacts(replies, facts, insurance) {
    if (!facts?.length)
        return replies;
    const k15 = (id) => id.slice(0, 15);
    const known = new Map();
    for (const r of insurance ?? []) {
        const k = k15(r.litify_pm__Matter__c);
        (known.get(k) ?? known.set(k, []).get(k)).push(r);
    }
    const target = (m) => {
        const rows = known.get(m);
        if (!rows)
            return undefined; // not known: only side-level facts
        // the board's order (board.ts: rows by insuranceId.localeCompare), so both pick the same record (Codex 10-14 #48 r2 #1)
        const plt = rows.filter((r) => sideOf(r) === 'PLT' && String(r.litify_pm__Claim_Number__c ?? '').trim() === '').map((r) => r.Id).sort((a, b) => a.localeCompare(b));
        return plt[0] ? k15(plt[0]) : null;
    };
    const latest = new Map();
    for (const f of facts) {
        if (f.side !== 'PLT' || f.kind === 'lor_send' || f.state === 'FAILED' || !f.entered_by)
            continue;
        const k = k15(f.matter_id), t = Date.parse(f.entered_at);
        const tg = target(k);
        // a side-level "no insurance" is the client's answer for the whole side, whatever record the reply sits on (Codex 10-14 #48 r2 #5)
        const onTarget = f.insurance_id ? tg !== undefined && tg !== null && k15(f.insurance_id) === tg
            : f.kind === 'no_insurance' || tg === undefined || tg === null;
        if (!onTarget)
            continue;
        if (Number.isFinite(t) && t > (latest.get(k) ?? -Infinity))
            latest.set(k, t);
    }
    if (!latest.size)
        return replies;
    const at = (s) => Date.parse(s.replace(/\+0000$/, 'Z'));
    const out = {};
    for (const [m, rs] of Object.entries(replies)) {
        const t = latest.get(k15(m));
        out[m] = t === undefined ? rs : rs.map((r) => (r.waiting && t > at(r.at) ? { ...r, waiting: false } : r));
    }
    return out;
}
//# sourceMappingURL=replies.js.map